import {ViewProps} from 'react-native';
import styled from 'styled-components/native';
import {
  BorderProps,
  ColorProps,
  FlexboxProps,
  HeightProps,
  LayoutProps,
  PositionProps,
  ShadowProps,
  SpaceProps,
  WidthProps,
  ZIndexProps,
  border,
  color,
  flexbox,
  height,
  layout,
  position,
  shadow,
  space,
  width,
  zIndex,
} from 'styled-system';

export interface StyledScrollViewProps
  extends BorderProps,
    ColorProps,
    HeightProps,
    LayoutProps,
    PositionProps,
    SpaceProps,
    ShadowProps,
    ViewProps,
    WidthProps,
    FlexboxProps,
    ZIndexProps {
  ref?: any;
}

export const StyledScrollView = styled.ScrollView<StyledScrollViewProps>`
  ${color}
  ${border}
  ${height}
  ${layout}
  ${position}
  ${shadow}
  ${space}
  ${width}
  ${flexbox}
  ${zIndex}
`;
